<template>
    <div>
      <input
      ref="filePicker"
      type="file"
      @change="handleFile"
      style="display: none">
    <button
      class="upload-button"
      @click.prevent="openFilePicker">
      <b v-if="this.file" v-html="this.filename"></b>
      <span v-else>{{ buttonText }}</span>
    </button>
      <small class="input-help">{{ helpText }}</small>
    </div>
</template>

<script>
import { truncate } from '@/utils/utils.format'

export default {
  name: 'FileUploadButton',
  props: {
    buttonText: {
      type: String,
      required: true
    },
    helpText: String,
    value: [File, null]
  },
  data () {
    return {
      filename: ''
    }
  },
  methods: {
    openFilePicker () {
      this.$refs.filePicker.click()
    },
    handleFile (event) {
      this.file = event.target.files[0]
    }
  },
  computed: {
    file: {
      get () {
        return this.value
      },
      set (file) {
        this.$emit('input', file)
      }
    }
  },
  watch: {
    value (file) {
      if (!file) {
        this.$refs.filePicker.value = ''
        this.filename = ''
      } else this.filename = truncate(file.name, 17)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/base";
</style>
